import { render, staticRenderFns } from "./CandidateJobPost.vue?vue&type=template&id=66d2bc5e&"
import script from "./CandidateJobPost.vue?vue&type=script&lang=js&"
export * from "./CandidateJobPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports